export default "__VITE_ASSET__CRa6ZrAb__"